// Ported from kima-ui/apps/web/src/components/ui.tsx, 2026-09-24.
// Dark brand asset and local meeting statuses; no terminal dependencies.
import type { ReactNode } from 'react';
import type { MeetingStatus } from '@kima-hub/contracts';
import { statusLabel } from './labels.js';

export function BrandMark({ className = '' }: { className?: string }) {
  return <img className={`brand-mark ${className}`} src="/brand/kima-mark.svg" alt="" />;
}

export function Field({ label, children, hint }: { label: string; children: ReactNode; hint?: string }) {
  return <label className="field"><span className="field__label">{label}</span>{children}
    {hint && <span className="field__hint">{hint}</span>}</label>;
}

export function Spinner({ size = 18 }: { size?: number }) {
  return (
    <span className="spinner" style={{ fontSize: size }} role="status" aria-label="Carregando">
      <svg viewBox="0 0 24 24" width="1em" height="1em" fill="none" stroke="currentColor"
        strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M12 3a9 9 0 1 0 9 9" />
      </svg>
    </span>
  );
}

export function ErrorNote({ message }: { message: string }) {
  return <div className="error-note" role="alert">
    <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
      <circle cx="12" cy="12" r="8" /><path d="M12 8v5M12 16h.01" />
    </svg><span>{message}</span>
  </div>;
}

export function EmptyState({ title, description, action }: { title: string; description?: string; action?: ReactNode }) {
  return <div className="empty-state"><h3>{title}</h3>{description && <p>{description}</p>}{action}</div>;
}

export function StatusChip({ status, title }: { status: MeetingStatus; title?: string }) {
  const tone = status === 'done' ? 'ready' : status === 'failed' ? 'failed' : status === 'partial' ? 'pending' : 'processing';
  return <span className={`status-chip status-chip--${tone}`} title={title}>
    <span className="status-chip__dot" aria-hidden="true" />{statusLabel(status)}
  </span>;
}
